import { FunctionComponent } from 'react';
import classnames from 'classnames';
import PampaPill from '@pampa-ui/pill';

import type { StepStatus } from '../../../../../../services/types';

type ViewProps = {
  stepStatus: StepStatus;
  shouldBeAnimated?: boolean;
}

const Badge: FunctionComponent<ViewProps> = ({ stepStatus, shouldBeAnimated = false }) => {
  const typeNotification = (stepStatus === 'completed' || stepStatus === 'conflict') ? 'green' : 'gray';
  const pillClassName = classnames({ 'animated-pill': shouldBeAnimated });

  return (stepStatus === 'completed' || stepStatus === 'conflict' || stepStatus === 'blocked')
    ? <PampaPill className={pillClassName} color={typeNotification} size="small" srLabel="icon pill" /> : null;
};

export default Badge;
